// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3zeUm","input":"styles_input__2ZNTL"};